module.exports = __webpack_public_path__ + "bg_medical.47c0b67a405a77a315a0.jpg";


//////////////////
// WEBPACK FOOTER
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/assets/images/bg_medical.jpg
// module id = ../../../../../src/assets/images/bg_medical.jpg
// module chunks = styles